import React from 'react';

// MUI components
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemAvatar';
import Skeleton from '@mui/material/Skeleton';
import Card from '@mui/material/Card';
import {Grid} from '@mui/material';

// Styled
import {StyledDataWrapper} from 'components/styled';

const DataSkeleton = () => {
  return (
    <StyledDataWrapper>
      <Grid container direction="row">
        <Grid item xs={12} md={3}>
          <Skeleton animation="pulse" height={20} width={80} />
          <Card style={{padding: '0 16px', marginTop: 16}} variant="outlined">
            <List>
              <ListItem>
                <List>
                  <ListItem>
                    <ListItemIcon>
                      <Skeleton animation="pulse" variant="circle" width={40} height={40} />
                    </ListItemIcon>
                    <ListItemText
                      primary={<Skeleton animation="pulse" height={20} width={200} />}
                      secondary={<Skeleton animation="pulse" height={20} width={100} />}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Skeleton animation="pulse" variant="circle" width={40} height={40} />
                    </ListItemIcon>
                    <ListItemText primary={<Skeleton animation="pulse" height={20} width={80} />} />
                  </ListItem>
                </List>
              </ListItem>
            </List>
          </Card>
        </Grid>
        <Grid item container xs={12} md={9} style={{paddingLeft: 16}} direction="column">
          <Skeleton animation="pulse" height={20} width={80} />
          <Card style={{padding: '16px', marginTop: 16}} variant="outlined">
            <ListItem>
              <ListItemText primary={<Skeleton animation="pulse" height={20} width={80} />} />
            </ListItem>
            <Skeleton animation="pulse" height={35} />
            <Skeleton animation="pulse" height={30} />
            <Skeleton animation="pulse" height={30} />
          </Card>
        </Grid>
      </Grid>
    </StyledDataWrapper>
  );
};
export default DataSkeleton;
